import { environment } from './../../../environments/environment';
import { LoginStorage } from './../../login/login.storage';
import { LoaderService } from './../../shared/loader/loader.service';
import { Injectable } from '@angular/core';
import { OmniRestService } from '../omni-rest.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class OmniMaisRodasAssinaturaService extends OmniRestService {
  constructor(
    http: HttpClient,
    loaderService: LoaderService,
    loginStorage: LoginStorage,
    router: Router
  ) {
    super(http, loaderService, loginStorage, router);
  }

  getBaseUrl(): string {
    return environment.URL_ASSINATURA;
  }

  getHeaders() {
    if (
      !this.loginStorage.loginAndTokenAsJson ||
      this.loginStorage.loginAndTokenAsJson === '{}'
    ) {
      return {
        'Content-Type': 'application/json',
      };
    }
    return {
      'Content-Type': 'application/json',
      'omni-autenticacao': this.loginStorage.loginAndTokenAsJson,
    };
  }
}
